import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const listReferenceChecks = createAsyncThunk(
  "listReferenceChecks",
  async ({ candidateId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/reference-check/list`,
        { candidateId }
      );
      if (data.success) return { candidateId, items: data.data || [] };
      return rejectWithValue(data.message);
    } catch (error) { return rejectWithValue(error.message); }
  }
);

const createReferenceCheck = createAsyncThunk(
  "createReferenceCheck",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/reference-check/create`,
        payload
      );
      if (data.success) return { candidateId: payload.candidateId, item: data.data };
      return rejectWithValue(data.message);
    } catch (error) { return rejectWithValue(error.message); }
  }
);

// Public endpoints — use bare axios so no Authorization header is sent
const getPublicReferenceForm = createAsyncThunk(
  "getPublicReferenceForm",
  async ({ token }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${baseUrl}/job-posting/api/public/reference-form/${token}`);
      if (data.success) return data.data;
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const submitPublicReferenceForm = createAsyncThunk(
  "submitPublicReferenceForm",
  async ({ token, payload }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${baseUrl}/job-posting/api/public/reference-form/${token}/submit`, payload);
      if (data.success) return data.data;
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export {
  listReferenceChecks,
  createReferenceCheck,
  getPublicReferenceForm,
  submitPublicReferenceForm,
};
